var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option,"update-options":{replaceMerge: 'series'},"theme":_vm.$vuetify.theme.dark ? _vm.themeDark : _vm.themeLight,"autoresize":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }